import { render, staticRenderFns } from "./yizhu.vue?vue&type=template&id=0bbc5f2e&scoped=true&"
import script from "./yizhu.vue?vue&type=script&lang=ts&"
export * from "./yizhu.vue?vue&type=script&lang=ts&"
import style0 from "./yizhu.vue?vue&type=style&index=0&id=0bbc5f2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbc5f2e",
  null
  
)

export default component.exports